export const FETCH_LIST_ALL_TEMPLATE_FODER_REQUEST = 'FETCH_LIST_ALL_TEMPLATE_FODER_REQUEST'
export const FETCH_LIST_ALL_TEMPLATE_FODER_SUCCESS = 'FETCH_LIST_ALL_TEMPLATE_FODER_SUCCESS'
export const FETCH_LIST_ALL_TEMPLATE_FODER_FALUIRE = 'FETCH_LIST_ALL_TEMPLATE_FODER_FALUIRE'

